<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title" v-text="title"></div>
        <DropdownScrollable :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset"/>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model.sync="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onEventOptions="onEventOptions"
          @onDataChange="DataOnChange"
          :company="company"
          :company_id="company_id"
          :category="category"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xoá mối nguy <strong>{{this.deleteName}}</strong> này không?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>

        <Dialog header="Rất cảnh báo" :visible.sync="popupWarning" id="warning_poins_errs">
          <span class="txt-center">
            Bạn không thể xoá mối nguy đã được đánh giá.
          </span>
          <template
              #footer
              class="justify-content-center"
            >
            <Button label="Xác nhận" @click="popupWarning = false" icon="pi pi-check" class="" />
          </template>
        </Dialog>

        <Dialog
          header="Duyệt mối nguy"
          :visible.sync="showApprovedDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          <form id="frm_action">
            <div style="max-width:450px">
              <span>Mối nguy này được tạo khi đánh giá. Sau khi duyệt, mối nguy này sẽ được hiển thị cho toàn bộ người dùng trong công ty. Bạn có chắc muốn duyệt không?</span>
            </div>
            <div class="">
              <label class="txt-right">Danh mục mối nguy<span class="required"></span></label>
              <Dropdown style="width: 100%" v-model="item_approved.selCategory" :options="options['category_id']?.items" optionValue="id"  optionLabel="name"
                @change="getListDangerEvent($event)" />
              <input class="input_tmp_validator" id="name_danger_edit" />
            </div>
            <div class="">
              <label class="txt-right">Tên mối nguy<span class="required"></span></label>
              <InputText
                v-model="item_approved.name"
                type="text"
                class="text-box-dialog input-text-box"
                placeholder="Nhập"
                maxlength="255"
                style="width:100%"
              />
              <input class="input_tmp_validator" id="name_danger_approved" />
            </div>
            <div class="" style="padding-top:5px;">
              <input type="radio" id="save_approved" v-model="item_approved.radio_btn" value="1">
              <span> Lưu thay đổi & duyệt mối nguy</span><br>
              <input type="radio" id="save" v-model="item_approved.radio_btn" value="2">
              <span> Chỉ lưu thay đổi</span><br>
              <input type="radio" id="javascript" v-model="item_approved.radio_btn" value="3">
              <span> Thay thế bằng mối nguy đã có</span>
            </div>
            <div v-if="item_approved.radio_btn==3" class="" style="padding-left: 15px;">
              <label class="txt-right">Chọn mối nguy có sẵn<span class="required"></span></label>
              <Dropdown style="width: 100%" v-model="item_approved.selDanger" :options="listDanger" optionValue="id"  optionLabel="name" placeholder="Chọn mối nguy có sẵn"/>
              <input class="input_tmp_validator" id="choose_danger_approved" />
            </div>
          </form>
            <template
              #footer
            >
              <Button
                label="Hủy"
                @click="showApprovedDialog = false"
                icon="pi pi-times"
                class="p-button-cancel"
              />
              <Button label="Xác nhận" @click="ApprovedData()" icon="pi pi-check" class="" />
            </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: null,
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      category_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      company_id: null,
      showApprovedDialog: false,
      item_approved: {
        id : null,
        name: null,
        status: null,
        active : null,
        selCategory: null,
        selDanger: null,
        radio_btn: 1
      },
      category_id_old: null,
      listDanger: [],
      popupWarning: false,
      category: null,
    }
  },
  async created() {
    await this.initParams();
    if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
      await this.getListCompany()
    }
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      console.log("this.$route.query.company_id", this.$route.query.company_id);
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
          this.company = {id: this.$route.query.company_id};
          setTimeout(() => {
            const query = Object.assign({}, this.$route.query);
            delete query.company_id;
            this.$router.replace({ query });
          }, 100);
        }
      }

      if (!this.$commonFuction.isEmpty(this.$route.query.category_id)){
        this.category = {id: this.$route.query.category_id};
        setTimeout(() => {
          const query = Object.assign({}, this.$route.query);
          delete query.category_id;
          this.$router.replace({ query });
        }, 100);
      }
    }
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    async 'company'() {
      if ((this.$store.getters?.type == this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company_id = this.company.id;
        await this.getListCategory();
        // this.componentKey++;
      }
    },
    // "company_id"() {
    //   if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
    //     this.company = {id: this.company_id};
    //     this.componentKey++;
    //   }
    // },
    // "category"() {
    //   this.componentKey++;
    // },
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
            if (this.offset > 0) {
              this.items.push(...res.data.data.company);
            } else {
              this.items = res.data.data.company;
            }
            this.total = res.data.data.total;
            this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async onEventOptions({event, key, data}) {
      console.log(key);
      if (key == "category_id") {
        this.category = null;
        this.category_obj = data;
        if (event == 'offset') {
          await this.getListCategory();
        }
      }
    },
    async getListCategory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.options["category_id"] = [];
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.category_obj.loading = true;
        this.category_obj.filters.company_id = this.company.id;
        await ApiRepository.post("/_api/category/options", {filters: this.category_obj.filters, limit: this.category_obj.limit, offset: this.category_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.category_obj.offset > 0 ) {
            this.category_obj.items.push(...res.data.data.list);
          } else{
            this.category_obj.items = res.data.data.list;
          }
          this.category_obj.total = res.data.data.total;
          this.category_obj.loading = false;
          this.options["category_id"] = this.category_obj;
        }).catch((err) => {
            console.log(err);
            this.category_obj.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
        this.company_id = this.$store.getters?.company_id;
        await this.getListCategory();
        // this.componentKey++
      }
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, 'title', this.dataModel.label);
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // if (that.$store.getters.controllers?.list_category_danger && that.$store.getters.controllers?.list_category_danger.includes('add')) {
        // actions.header = {name: 'add', icon: 'plus', path: `dangers/add`};
      // }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        console.log("rowData",rowData)
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.$store.getters.controllers?.list_category_danger && that.$store.getters.controllers?.list_category_danger.includes('edit') && that.$store.getters.controllers?.list_category && that.$store.getters.controllers?.list_category.includes('edit')) {
          if(rowData.status == 'WAITTING'){
            buttons.approve = {name: 'approve', icon: '', key: 'id'}
          }else{
            buttons.edit = {name: 'edit', icon: 'pencil', key: 'category_id', path: `list-category/edit/`};
          }
        }
        if (that.$store.getters.controllers?.list_category_danger && that.$store.getters.controllers?.list_category_danger.includes('delete')) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          if (data.data.status == "WAITING") {
            const danger = data.data;
            this.item_approved = {
              id : danger.id,
              name: danger.name,
              status: danger.status,
              active : danger.active,
              selCategory: danger.category?.id,
              selDanger: null,
              radio_btn: 1
            }
            this.category_id_old = danger.category_id;
            this.showApprovedDialog = true
            this.getListDanger();
          } else {
            this.dialogMode = action.name
            if (action.path !== undefined && action.path) {
              localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
              this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id }  })
            } else  {
              this.page_transaction = pageTransaction.toString();
              localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
              this.editId = data.data[action.key]
              this.displayDialog = true
              this.editDialogKey++
            }
          }
          break
        case 'delete':
          if (data.data.evaluations.length > 0) {
            this.popupWarning = true;
            break;
          }
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'approve':
          var danger_approve = data.data;
            this.item_approved = {
              id : danger_approve.id,
              name: danger_approve.name,
              status: danger_approve.status,
              active : danger_approve.active,
              selCategory: danger_approve.category?.id,
              selDanger: null,
              radio_btn: 1
            }
            this.category_id_old = danger_approve.category_id;
            this.showApprovedDialog = true
            this.getListDanger();
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    toastSuccess(text){
      this.$commonFuction.is_loading(false);
      this.$toast.add({ severity: 'success', summary: 'Success', detail: text, life: 3000 })
    },
    async validateDataApproved() {
      let name_danger_approved = document.getElementById("name_danger_approved");
      if (this.item_approved.name == undefined || this.item_approved.name == null || this.item_approved.name == "") {
        name_danger_approved.setCustomValidity("Tên mối nguy không được để trống!");
      } else if (this.item_approved.name.length > 255) {
        name_danger_approved.setCustomValidity("Tên mối nguy không được quá 255 ký tự!");
      } else {
        name_danger_approved.setCustomValidity("");
      }
      if(this.item_approved.radio_btn == 3){
        let choose_danger_approved = document.getElementById("choose_danger_approved");
        if(this.item_approved.selDanger == undefined || this.item_approved.selDanger == null){
          choose_danger_approved.setCustomValidity("Vui lòng chọn mối nguy thay thế!");
        }else{
          choose_danger_approved.setCustomValidity("");
        }
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async ApprovedData(){
      this.$commonFuction.is_loading(true);
      if (await this.validateDataApproved()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var objects = {
        company_id : company_id,
        category_id : this.item_approved.selCategory,
        danger_id : this.item_approved.selDanger,
        id : this.item_approved.id,
        name : this.item_approved.name,
        radio_btn : this.item_approved.radio_btn,
        category_id_old : this.category_id_old,
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      const headers = {
        "Authorization": "Bearer "+token,
      };   
      var that = this
      await ApiRepository.post("/_api/danger/change", objects, {headers}).then(async function (response) {
        if (response.status === 200) {
          that.toastSuccess('Lưu dữ liệu thành công')
          that.showApprovedDialog = false;
          that.item_approved = {
            id : null,
            name: null,
            status: null,
            active : null,
            selCategory: null,
            selDanger: null,
            radio_btn: 1
          },
          that.category_id_old = null;
          that.componentKey++;
          that.$commonFuction.is_loading(false);
        } else {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: response.data.message,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        }
      }).catch((err) => {
        if(err.response && err.response.data && err.response.data.message == 'DANGER_EXSIT'){
          var text_err = 'Mối nguy đã tồn tại trong phiếu đánh giá'
          if(err.response.data.data){
            text_err += ' "'+err.response.data.data.name+'"'
          }
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: text_err,
            life: 5000
          });
        }else{
          that.$toast.add({
          severity: 'error',
          summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: err,
          life: 3000
        });
        }
        
        that.$commonFuction.is_loading(false);
      })
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/danger/delete", {danger_id: that.deleteId, company_id: that.company.id}, {headers}).then(function () {
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            })
        })
      }
    },
    async getListDangerEvent(event) {
      console.log(event);
      await this.getListDanger()
    },
    async getListDanger(){
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var listDanger = []
      var filters = {active:true,status : "APPROVED"}
      filters.category_id = this.item_approved.selCategory
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id && filters.category_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/danger/options", {filters,limit: null, offset: 0, company_id: company_id}, {headers}).then(async function (response) {
            var data = response.data.data;
            listDanger = data.list;
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
        this.item_approved.selDanger = null
        this.listDanger = listDanger
      }

    }
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}

label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.button-box {
  /* min-height: 45px !important; */
  width: 30px !important;
  height: 30px;
  margin-left : 2px;
}
.button-box-1 {
  /* min-height: 45px !important; */
  /* width: 4% !important;
  height: 45px; */
  width : 34px !important;
  margin-left : 6px;
}
.number-box {
  display: block;
  /* min-height: 48px !important; */
  width: 46% !important;
}
.text-box-dialog {
  display: block;
  /* min-height: 48px !important; */
  min-width: 400px;
}
.number-text-box {
  padding-top: 11px !important;
  padding-bottom: 11px !important;
  /* padding-left: 10px !important; */
}
/**css table */
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel{
  background: #FFFAF0;
  border: 1px solid #d0dde7;
  color : #000000
}

#warning_poins_errs .p-dialog-footer{
  justify-content: center;
}
</style>